var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.141,
    height: 14.453,
    viewBox: "0 0 14.141 14.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000FFF;stroke:#000FFF;stroke-width:0.7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.335,0H1.073A.576.576,0,0,0,.56.313.584.584,0,0,0,.605.921L5.1,7.249l0,.006a1.284,1.284,0,0,1,.252.762v5.159a.574.574,0,0,0,.574.577.591.591,0,0,0,.226-.045l2.524-.963a.547.547,0,0,0,.376-.539V8.017a1.284,1.284,0,0,1,.252-.762l0-.006L13.8.92a.584.584,0,0,0,.045-.608A.576.576,0,0,0,13.335,0ZM8.743,6.841a1.987,1.987,0,0,0-.387,1.175v4.1L6.052,13V8.017a1.987,1.987,0,0,0-.388-1.175L1.3.7H13.1Zm0,0",
    transform: "translate(-0.134 0.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.f3a08a6a3a7215aa7967f597783f60c3.svg";
export { ForwardRef as ReactComponent };